import { render, staticRenderFns } from "./detailForm.vue?vue&type=template&id=1c97ecb6&lang=pug&"
import script from "./detailForm.vue?vue&type=script&lang=js&"
export * from "./detailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports